import { ChannelsContainer } from '@/modules/Channels';

export const Channels = (): JSX.Element => <ChannelsContainer />;

export default Channels;
